<button mat-mini-fab [disabled]="disable"
        (click)="setCurrentMedia()">
  <mat-icon>{{direction === 'next' ? 'chevron_right' : 'chevron_left'}}</mat-icon>
</button>
